var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendorHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67409 0C1.20334 0 0 1.07143 0 2.38095V21.4286C0 22.7381 1.20334 23.8095 2.67409 23.8095H8.02228V21.5476L21.3928 9.64286V7.14286L13.3705 0H2.67409ZM12.0334 1.78571L19.3872 8.33333H12.0334V1.78571ZM21.5265 13.0952C21.3928 13.0952 21.1254 13.2143 20.9916 13.3333L19.6546 14.5238L22.4624 17.0238L23.7994 15.8333C24.0669 15.5952 24.0669 15.119 23.7994 14.881L22.0613 13.3333C21.9276 13.2143 21.7939 13.0952 21.5265 13.0952ZM18.8524 15.2381L10.6964 22.5V25H13.5042L21.6602 17.7381L18.8524 15.2381Z",
    fill: "#428BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorHistory);
export default __webpack_public_path__ + "static/media/vendor-history.2a38e2d1e758eb9865ebec02701a97bb.svg";
export { ForwardRef as ReactComponent };